import * as moment from 'moment';
import {Moment} from 'moment';

export class OverdueLoadAction {
  deliveryNumber: string;
  user: string;
  type: OverdueLoadActionType;
  carrierVendorNumber: string;
  destinationCountry: string;
  destinationGlid: string;
  date?: Moment;
  previousDeliveryDate?: Moment;
  newDeliveryDate?: Moment;
  previousGiDate?: Moment;
  newGiDate?: Moment;
  status?: OverdueLoadActionStatus;
  duplicatedDeliveryNumber?: string;
  chepCommentary?: string;
  haulierCommentary?: string;

  static fromDto(data: any): OverdueLoadAction {
    if (data == null) {
      return null;
    }

    const result = new OverdueLoadAction();

    result.deliveryNumber = data.delivery_number;
    result.user = data.user;
    result.type = data.type;
    result.carrierVendorNumber = data.carrier_vendor_number;
    result.destinationCountry = data.destination_country;
    result.destinationGlid = data.destination_glid;
    result.date = data.date;
    result.previousDeliveryDate = data.previous_delivery_date ? moment(data.previous_delivery_date) : null;
    result.newDeliveryDate = data.new_delivery_date ? moment(data.new_delivery_date) : null;
    result.previousGiDate = data.previous_gi_date ? moment(data.previous_gi_date) : null;
    result.newGiDate = data.new_gi_date ? moment(data.new_gi_date) : null;
    result.status = data.status === OverdueLoadActionStatus.OLD_REJECTED ? OverdueLoadActionStatus.REJECTED : data.status;
    result.duplicatedDeliveryNumber = data.duplicated_delivery_number;
    result.chepCommentary = data.chep_commentary;
    result.haulierCommentary = data.haulier_commentary;

    return result;
  }
}

export enum OverdueLoadActionType {
  INFO_REQUEST = 'INFO_REQUEST',
  HOLIDAY = 'HOLIDAY',
  DUPLICATE = 'DUPLICATE',
  COMPLETE = 'COMPLETE',
  OTHER = 'OTHER',
  PROBLEM = 'PROBLEM',
  HOLIDAY_REVIEW = 'HOLIDAY_REVIEW',
  DUPLICATE_REVIEW = 'DUPLICATE_REVIEW',
  COMPLETE_REVIEW = 'COMPLETE_REVIEW',
  OTHER_REVIEW = 'OTHER_REVIEW',
  PROBLEM_REVIEW = 'PROBLEM_REVIEW'
}

export enum OverdueLoadActionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  OLD_REJECTED = 'OLD_REJECTED',
}

export class OverdueLoadActionRequest {
  delivery_number: string;
  user: string;
  type: OverdueLoadActionType;
  previous_delivery_date: string;
  new_delivery_date: Moment | string;
  previous_gi_date: string;
  new_gi_date: Moment | string;
  status: OverdueLoadActionStatus;
  duplicated_delivery_number: string;
  chep_commentary: string;
  haulier_commentary: string;
  carrier_vendor_number: string;
  origin_country: string;
  origin_glid: string;
  destination_country: string;
  destination_glid: string;

  static fromActionRequest(actionRequest: OverdueLoadActionRequest) {
    const newActionRequest = new OverdueLoadActionRequest();

    newActionRequest.delivery_number = actionRequest.delivery_number;
    newActionRequest.user = actionRequest.user;
    newActionRequest.type = actionRequest.type;
    newActionRequest.previous_delivery_date = actionRequest.previous_delivery_date;
    newActionRequest.new_delivery_date = actionRequest.new_delivery_date;
    newActionRequest.previous_gi_date = actionRequest.previous_gi_date;
    newActionRequest.new_gi_date = actionRequest.new_gi_date;
    newActionRequest.status = actionRequest.status;
    newActionRequest.duplicated_delivery_number = actionRequest.duplicated_delivery_number;
    newActionRequest.chep_commentary = actionRequest.chep_commentary;
    newActionRequest.haulier_commentary = actionRequest.haulier_commentary;
    newActionRequest.carrier_vendor_number = actionRequest.carrier_vendor_number;
    newActionRequest.origin_country = actionRequest.origin_country;
    newActionRequest.origin_glid = actionRequest.origin_glid;
    newActionRequest.destination_country = actionRequest.destination_country;
    newActionRequest.destination_glid = actionRequest.destination_glid;

    return newActionRequest;
  }
}
